export default {
	sec_01: {
		title: {
			one: 'Payment',
		},
		desc: {
			one: 'Payment system using JP WORLD Pay API',
		},
	},

	sec_02: {
		title: {
			one: 'Quick Guide',
		},
		step: {
			one: {
				one: 'join the membership',
				two: 'Please sign up for membership ',
				three: 'on the JP WORLD PAY website.',
			},
			two: {
				one: 'Log in',
				two: "All of JP WORLD PAY's services can",
				three: 'be used after logging in.',
			},
			three: {
				one: 'Merchant registration',
				two: 'You can register as a merchant ',
				three: 'through the merchant menu. ',
				four: 'Please enter your merchant ',
				five: 'name and ID.',
			},
			four: {
				one: 'API Issuance',
				two: 'Lorem Ipsum Lorem Ipsum',
				three: 'Lorem Ipsum',
			},
		},
	},
};
